<template>
    <div class="row gx-3">
        <pc-label
            v-bind:label="label"
            v-bind:for-id="inputId"
            v-bind:show-required="required"
            v-bind:show-help="showHelp"
            v-bind:help-link="showHelpLinkOnly"
            class="col-12"
            v-on:help-clicked="emitHelpClicked" />
        <div class="col-12">
            <slot name="help" />
        </div>
        <pc-input-group class="col-12">
            <pc-textarea
                v-bind="binder"
                v-bind:maxlength="maxlength"
                data-test-role="textarea-element"
                v-bind:validation-group-id="inputId"
                v-bind:rows="6"
                v-bind:max-auto-expand-rows="12"
                v-on="listeners" />
        </pc-input-group>
        <validation-render-helper
            v-bind:validation-error="validationError"
            v-bind:validation-group-id="inputId" />
    </div>
</template>

<script>
    import base, { validationRenderHelper } from "./_elementBase";

    export default {
        components: { validationRenderHelper },
        extends: base,
        computed: {
            maxlength() {
                return this.element.AuxiliaryModel.maxlength;
            }
        }
    };
</script>
